import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-4_5",
  "use": "icon-4_5-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-4_5\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M19.47,0H4.53A2.08,2.08,0,0,0,2.4,2V22a2.08,2.08,0,0,0,2.13,2H19.47a2.08,2.08,0,0,0,2.13-2V2A2.08,2.08,0,0,0,19.47,0Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol